import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Container, Text } from '@pixi/react';
import { useMemo } from 'react';
import { withTextMetrics } from '../../../utils/textMetricsUtils';
import { isTestEnvironment } from '../../../utils/utils';
function getPixiObjectData(pixiData) {
    if (!isTestEnvironment()) {
        return null;
    }
    if (!pixiData) {
        return null;
    }
    if (typeof pixiData === 'string') {
        return { type: pixiData };
    }
    return pixiData;
}
function getX(xAlignment, textMetrics) {
    switch (xAlignment) {
        case 'left': {
            return 0;
        }
        case 'center': {
            return -Math.round(textMetrics.width / 2);
        }
        case 'right': {
            return -Math.round(textMetrics.width);
        }
    }
}
function getY(yAlignment, textMetrics) {
    switch (yAlignment) {
        case 'top': {
            return 0;
        }
        case 'center': {
            return -Math.round(textMetrics.height / 2);
        }
        case 'bottom': {
            return -Math.round(textMetrics.height);
        }
    }
}
export const AlignedText = ({ text, textStyle, textMetrics: textMetricsProp, x, y, pixiData, xAlignment = 'center', yAlignment = 'center' }) => {
    // TODO: Only calculate this if required by alignment:
    const textMetrics = useMemo(() => {
        if (textMetricsProp) {
            return textMetricsProp;
        }
        return withTextMetrics({ label: text, textStyle }).textMetrics;
    }, [text, textMetricsProp, textStyle]);
    // TODO: Should x and y be rounded on the Container?
    return (_jsx(Container, { x: x, y: y, children: _jsx(Text, { "pixi-data": getPixiObjectData(pixiData), text: text, style: textStyle, x: getX(xAlignment, textMetrics), y: getY(yAlignment, textMetrics) }) }));
};
